/* global pnTopbar */
import { loadLanguageAsync } from '../../setup/i18nSetup'

export default {
  state: {
    topBarLang: null,
    wasLoggedIn: false
  },
  actions: {
    setLocalizationState({ rootState }) {
      rootState.lang = pnTopbar.language || 'en'
      rootState.market = 'SE'
      if (pnTopbar.user) {
        rootState.userType = pnTopbar.isBusinessUser ? 'company' : 'public'
      }

      loadLanguageAsync(rootState.lang)

      pnTopbar.onChangeLanguage = lang => {
        rootState.lang = lang
        loadLanguageAsync(rootState.lang)
      }

      pnTopbar.onChangeMarket = market => {
        rootState.market = market
      }

      pnTopbar.onLogout = () => {
        pnTopbar.login()
      }

      const markets = ['SE']
      const languages = [
        {
          key: 'sv',
          name: 'Svenska'
        },
        {
          key: 'en',
          name: 'English'
        }
      ]

      if (process.env.NODE_ENV !== 'production') {
        languages.push({ key: 'zu', name: 'Zulu' })
      }

      if (!markets.includes(rootState.market)) {
        pnTopbar.market = 'SE' // Set default to SE if market is not supported
        window.location.reload()
        return
      }

      pnTopbar.markets = markets
      pnTopbar.languages = languages
    },
    setAccessToken({ rootState }) {
      rootState.accessToken = pnTopbar.access_token || 'anonymous'
    },
    checkUserAccess({ getters }) {
      if (pnTopbar.isLoggedIn && !getters.isAuthorizedToAccessService) {
        window.location.href = process.env.VUE_APP_NO_ACCESS_REDIRECT_URL
      }
    }
  },
  getters: {
    isLoggedIn: () => {
      if (typeof pnTopbar !== 'undefined') {
        return pnTopbar.isLoggedIn
      }
    },
    isReadOnlyMode: () => {
      return pnTopbar.readOnlyMode
    },
    // Agreement customer
    isBusinessUser: () => {
      return pnTopbar.isBusinessUser
    },
    isAuthorizedToAccessService: (state, getters) => {
      // if you are logged in as a business user but don't have the correct authority
      if (pnTopbar.isLoggedIn) {
        return !getters.isBusinessUser || getters.hasAuthority
      }

      if (getters.isBusinessUser && !getters.hasAuthority) {
        return false
      }

      return true
    },
    hasAuthority: () => {
      return process.env.VUE_APP_AUTHORITY_IDS.split(',').some(id => {
        return pnTopbar.user.authoritylist.includes(id)
      })
    }
  }
}
